import axios from '@/lib/axios';
import { FixedAsset, PaymentSchedule, Product, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0690. 支払予定登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_schedules
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  year_month: string;
  monthly_amount?: number;
  spot_amount?: number;
};
const createPaymentSchedule = (props: Props): Promise<PaymentSchedule> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_schedules`, props);
};

export const useCreatePaymentSchedule = () => {
  return useMutation({
    mutationFn: createPaymentSchedule,
  });
};
